export default {
  apiKey: 'AIzaSyDvyspBnGhLog-bpD18K-QpLk-XmN36JHY',
  authDomain: 'memory-game-3c1b1.firebaseapp.com',
  databaseURL: 'https://memory-game-3c1b1.firebaseio.com',
  projectId: 'memory-game-3c1b1',
  storageBucket: '',
  messagingSenderId: '564430962620',
}
